import {
  Button,
  Heading,
  Modal,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react';
import { FC } from 'react';

export interface LeaveCallModalV2Props {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

/**
 * Confirmation modal for patients leaving a call in V2 call experience.
 *
 * Displayed when patient clicks the "Leave Session" button in the Daily.co tray.
 * Allows patient to confirm or cancel their intention to leave the call.
 *
 * Features:
 * - Simple confirmation interface (patient-specific, no status selection)
 * - Matches V1 modal content and behavior
 * - Integrates with existing survey flow
 * - Analytics tracking for cancel action
 */
export const LeaveCallModalV2: FC<LeaveCallModalV2Props> = ({
  isOpen,
  onClose,
  onConfirm,
}) => {
  return (
    <Modal isOpen={isOpen} size="sm" onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent
        bg="surface.default"
        overflow="hidden"
        borderColor="border.default"
        borderWidth={1}
        borderRadius={10}
        color="text.default"
      >
        <ModalHeader
          as={Heading}
          fontFamily="Plus Jakarta Sans"
          size="md"
          mt={5}
          pb={0}
        >
          Are you sure you want to leave the call?
        </ModalHeader>

        <ModalFooter justifyContent="center" mb={5} gap={10}>
          <Button
            data-testid="cancel-leave-call-button"
            variant="outline"
            color="text.default"
            borderColor="border.default"
            onClick={onClose}
            _hover={{
              color: 'green.600',
              bgColor: 'surface.light',
              borderColor: 'green.600',
            }}
          >
            Cancel
          </Button>
          <Button
            data-testid="confirm-leave-call-button"
            variant="solid"
            color="white"
            bg="orange.500"
            onClick={onConfirm}
            _hover={{
              bg: 'orange.600',
            }}
          >
            Leave Call
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
